import apiService from 'src/enviroment';
import { loaderService } from 'src/services/loaderService';

const getSpareParts = async (params) => {
  loaderService.show();
  try {
    const { status, data } = await apiService.post('/reportes/buscador/pedido_csa/', params);
    if (status === 200) {
      return data;
    }
  } catch (error) {
    return false;
  } finally {
    loaderService.hide();
  }
};

const getSparePartsFiltered = async (dism) => {
  try {
    const response = await apiService.get(`/reportes/buscador/pedido_csa/?csa=${dism}`,)
    if (response.status === 200) {
      return response.data
    }
  } catch (error) {
    return false
  }
}

const sendMessage = async (params) => {
  loaderService.show();
  try {
    const { status, data } = await apiService.put(
      '/reportes/buscador/pedido_csa/',
      params,
    );
    if (status === 200) {
      return data;
    }
  } catch (error) {
    return false;
  } finally {
    loaderService.hide();
  }
};

export { getSpareParts, sendMessage, getSparePartsFiltered };
